// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredients__BreadBottom__V9Uci","BreadTop":"BurgerIngredients__BreadTop__10qEX","Seeds1":"BurgerIngredients__Seeds1__1MXnd","Seeds2":"BurgerIngredients__Seeds2__2i9fE","Meat":"BurgerIngredients__Meat__1cfTz","Cheese":"BurgerIngredients__Cheese__18Pid","Salad":"BurgerIngredients__Salad__2uWEC","Bacon":"BurgerIngredients__Bacon__1LCF9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredients.css
// module id = 149
// module chunks = 3